
import axios from '@axios'

const group = 'report/'
const route = 'panel/performance_panel'

export default {
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    index(context, { itemsPerPage, page, filters }) {
      let pagination = `?page=${page}&items_per_page=${itemsPerPage}`
      return axios.post(`${group + route + pagination}`, filters)
    },

    exportExcel(context, { filters }) {
      return axios.post(`${group + route}/export_excel`, filters, { responseType: 'blob' })
    },


    exportPdf(context, { filters }) {
      return axios.post(`${group + route}/export_pdf`, filters, { responseType: 'blob' })
    },

    //card de resumo das vendas
    summarySales(context, filters) {
      return axios.post(`${group + route}/summary_total_sales`, filters)
    },

    //grafico de vendas no periodo
    salesOverTime(context, filters) {
      return axios.post(`${group + route}/chart_sales_over_time`, filters)
    },

    cardSmallMetrics(context, filters) {
      return axios.post(`${group + route}/card_small_metrics`, filters)
    },

    salesByChannel(context, filters) {
      return axios.post(`${group + route}/chart_sales_by_channel`, filters)
    },

    chartScheduledAppointments(context, filters) {
      return axios.post(`${group + route}/chart_scheduled_appointments`, filters)
    },
    chartOccupancyRate(context, filters) {
      return axios.post(`${group + route}/chart_occupancy_rate`, filters)
    },
    chartRegularCustomerRate(context, filters) {
      return axios.post(`${group + route}/chart_regular_customer_rate`, filters)
    },


  },

}
